import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ContactsTable } from "./ContactsTable";
import type { Contact } from "@/types/contact";

interface ContactsTableWrapperProps {
  contacts: Contact[];
  isLoading: boolean;
  onEdit: (contact: Contact) => void;
  onDelete: (id: string) => void;
}

export const ContactsTableWrapper = ({
  contacts,
  isLoading,
  onEdit,
  onDelete,
}: ContactsTableWrapperProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Lista de Contatos</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div>Carregando...</div>
        ) : (
          <ContactsTable
            contacts={contacts}
            onEdit={onEdit}
            onDelete={onDelete}
          />
        )}
      </CardContent>
    </Card>
  );
};